var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.716 4.353H3.918c.358-1.357 1.223-2.014 2.337-2.014.87 0 1.54.408 2.018.786l.696-1.482C8.233 1.027 7.32.68 6.255.68c-2.113 0-3.71 1.352-4.196 3.674h-1.03L.638 5.412h1.282a8.38 8.38 0 000 .994h-.89L.638 7.48h1.422c.487 2.317 2.083 3.66 4.196 3.66 1.024 0 1.973-.314 2.684-.93l-.706-1.482c-.432.348-1.103.75-1.978.75-1.119 0-1.979-.64-2.337-1.998h2.367l.512-1.074H3.754a8.38 8.38 0 010-.994h3.48l.482-1.059z",
    fill: "#fff"
  })));
}
export default SvgEur;